import type { DiscoveryApi, DiscoverySource } from '../data/discovery';

export const sourcesForEntries = (entries: DiscoveryApi[]): DiscoverySource[] => {
  const sources = new Map<string, DiscoverySource>();
  for (const entry of entries) {
    for (const lane of entry.lanes) sources.set(lane.source.id, lane.source);
  }
  return [...sources.values()];
};
